<template>
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
  >
    <path d="M8 0.5C12.4183 0.5 16 4.08172 16 8.5C16 12.9183 12.4183 16.5 8 16.5C3.58172 16.5 0 12.9183 0 8.5C0 4.08172 3.58172 0.5 8 0.5ZM8 1.5C4.13401 1.5 1 4.63401 1 8.5C1 12.366 4.13401 15.5 8 15.5C11.866 15.5 15 12.366 15 8.5C15 4.63401 11.866 1.5 8 1.5ZM11.3584 6.14645C11.532 6.32001 11.5513 6.58944 11.4163 6.78431L11.3584 6.85355L7.35355 10.8584C7.17999 11.032 6.91056 11.0513 6.71569 10.9163L6.64645 10.8584L4.64645 8.85842C4.45118 8.66316 4.45118 8.34658 4.64645 8.15131C4.82001 7.97775 5.08944 7.95846 5.28431 8.09346L5.35355 8.15131L7 9.798L10.6513 6.14645C10.8466 5.95118 11.1632 5.95118 11.3584 6.14645Z" />
  </svg>
</template>
